import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent implements OnInit {
  visible = false;
  @Output() close = new EventEmitter<void>();

  constructor(
    public userService: UserService,
    public sharedService: SharedService
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.visible = true;
    }, 0);
  }

  signOut(): void {
    this.userService.signOut();
    this.close.emit();
  }

  setColorTheme(): void {
    const user = this.userService.user;
    const newTheme = user.colorTheme === 'dark' ? 'light' : 'dark';
    // update user document with new theme
    this.userService
      .updateUser(user.uid, { colorTheme: newTheme })
      // then set cookie
      .then(() => window.localStorage.setItem('gleemo-color-theme', newTheme));
  }
}
